import React from 'react';
import { Box, Card, Typography, IconButton } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import { useReviews } from '../../assets/api/useGetApi';
import { useNavigate } from 'react-router-dom';


interface ActivityLMSCourseCardProps {
    item?: any;
    onClick?: () => void;
}

const ActivityLMSCourseCard: React.FC<ActivityLMSCourseCardProps> = ({ item, onClick }) => {
    const navigate = useNavigate();
    const { data: reviewsData }: any = useReviews(item?.id);
    const averageRating = reviewsData?.overallReview?.averageRating || 0;
    const totalReviews = reviewsData?.overallReview?.totalReviews || 0;

    return (
        <Card
            onClick={() => onClick ? onClick() : navigate(`/activitylms/${item?.event_id || item?.id}`, { state: { courseImage: item?.image, coursePrice: item?.price, tax: item?.tax, tax_type: item?.tax_type, shipping_charges: item?.shipping_charges, courseName: item?.title || item?.course_name } })}
            sx={{
                borderRadius: "15px",
                border: "1px solid #E7E7E7",
                overflow: "hidden",
                cursor: "pointer",
                "&:hover": {
                    transform: "translateY(-3px)",
                },
                transition: "transform 0.3s ease",
                p: 1.5,
                display: "flex",
                flexDirection: "column",
                gap: 1,
                height: "100%",
            }}
        >
            {/* ── Image ── */}
            <Box
                component="img"
                src={item?.image}
                alt={item?.title}
                sx={{
                    width: "100%",
                    height: "220px",
                    objectFit: "fill",
                    borderRadius: "12px",
                }}
            />

            {/* ── Chip and Price ── */}
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "10px" }}>
                {/* ── Title ── */}
                <Typography variant="body1" fontWeight={500}>
                    {item?.title}
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", color: "red.main" }}>
                    <CurrencyRupeeIcon sx={{ fontSize: "20px" }} />
                    <Typography variant="h6" fontWeight={600}>
                        {item?.price}
                    </Typography>
                </Box>
            </Box>


            {/* ── Description ── */}
            <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    mb: 0.5
                }}
            >
                {item?.description}
            </Typography>

            {/* ── Divider ── */}
            <Box sx={{ height: "1px", bgcolor: "#E0E0E0", mt: "auto", mb: 0.5 }} />

            {/* ── Footer: Stars & Action Button ── */}
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                    {[...Array(5)].map((_, i) => (
                        <StarIcon key={i} sx={{ color: i < Math.round(averageRating) ? "#FFD700" : "#FFD700", fontSize: "24px" }} />
                    ))}
                    <Typography variant="caption" color="text.secondary" sx={{ ml: 1, fontSize: "0.8rem", fontWeight: 500, marginTop: "5px" }}>
                        {totalReviews === 0 ? "10K Reviews" : `${totalReviews} Reviews`}
                    </Typography>
                </Box>
                <IconButton
                    sx={{
                        bgcolor: "red.main",
                        color: "#fff",
                        "&:hover": { bgcolor: "red.main" },
                        width: 40,
                        height: 40
                    }}
                >
                    <ArrowForwardIcon sx={{ fontSize: "20px" }} />
                </IconButton>
            </Box>
        </Card>
    );
}

export default ActivityLMSCourseCard;